import React from 'react'
import { Grid, IconButton, Typography, MenuItem } from '@material-ui/core'
import { ChevronLeft, ChevronRight } from 'lucide-react'
import { useStyles } from './style'
import SelectInput from '../SelectInput'

export const TablePaginationFooter = ({
  pageNumber,
  rowsPerPage,
  totalItems,
  loading,
  onChangePage,
  onChangeRowsPerPage,
  title
}) => {
  const classes = useStyles()
  const totalPages = Math.ceil(totalItems / rowsPerPage) || 1

  return (
    <Grid
      container
      component="footer"
      className={classes.containerPagination}
      spacing={1}
    >
      <Grid item xs={12} className={classes.exibitionPagination}>
        <Grid item xs={12} sm={6} className={classes.contentPagination}>
          <Typography variant="body2" className={classes.countPerPage}>
            Exibindo {totalItems > 0 ? (pageNumber - 1) * rowsPerPage + 1 : 0}
            –{Math.min(pageNumber * rowsPerPage, totalItems)} de {totalItems}{' '}
            {title}
          </Typography>
          <div className={classes.perPageSelect}>
            <Typography
              variant="body2"
              component="span"
              style={{ marginRight: 4 }}
            >
              Mostrar:
            </Typography>
            <div className={classes.selectWrapper}>
              <SelectInput
                value={rowsPerPage}
                onChange={e => onChangeRowsPerPage(Number(e.target.value))}
                size="small"
                inputProps={{ 'aria-label': 'Linhas por página' }}
              >
                {[10, 25, 50, 100].map(val => (
                  <MenuItem key={val} value={val}>
                    {val}
                  </MenuItem>
                ))}
              </SelectInput>
            </div>
          </div>
        </Grid>

        <Grid item xs={12} sm={6} className={classes.contentPagination}>
          <Grid item xs={12} className={classes.numberPerPage}>
            <IconButton
              onClick={() => onChangePage(pageNumber - 1)}
              disabled={pageNumber === 1 || loading}
              aria-label="Página anterior"
              className={classes.buttonNext}
            >
              <ChevronLeft size={24} />
            </IconButton>

            <Typography
              variant="body2"
              className={classes.pageNumberOfRowsPage}
              style={{ margin: '0 8px' }}
            >
              {pageNumber} de {totalPages}
            </Typography>

            <IconButton
              onClick={() => onChangePage(pageNumber + 1)}
              disabled={pageNumber >= totalPages || loading}
              aria-label="Próxima página"
              className={classes.buttonNext}
            >
              <ChevronRight size={24} />
            </IconButton>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  )
}
